import { useState } from "react";
import { ChevronDown, Clock } from "lucide-react";
import { DAYS, formatSlots, hasHours, isOpenNow, todayKey } from "@/lib/hours";

export const OpenBadge = ({ hours, testId }) => {
  const open = isOpenNow(hours);
  if (open === null) return null;
  return (
    <span data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] uppercase tracking-[0.2em] font-bold ${open ? "bg-emerald-500 text-black" : "bg-white/10 text-zinc-200"}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${open ? "bg-black animate-pulse" : "bg-zinc-400"}`} />
      {open ? "Ouvert maintenant" : "Fermé"}
    </span>
  );
};

// today's hours + the full week on demand
export const PlaceHours = ({ placeId, hours, source }) => {
  const [open, setOpen] = useState(false);
  if (!hasHours(hours)) return null;
  const today = todayKey();
  return (
    <div className="mt-4" data-testid={`place-hours-${placeId}`}>
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} data-testid={`place-hours-toggle-${placeId}`}
        className="inline-flex items-center gap-2 text-sm text-zinc-200 hover:text-white">
        <Clock className="w-4 h-4 text-zinc-400" /> Aujourd'hui : <strong className="text-white">{formatSlots(hours[today])}</strong>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="mt-2 grid grid-cols-[96px_1fr] gap-x-4 gap-y-1 text-sm max-w-sm" data-testid={`place-hours-week-${placeId}`}>
          {DAYS.map(([k, label]) => (
            <li key={k} className={`contents ${k === today ? "text-white font-semibold" : "text-zinc-300"}`}>
              <span>{label}</span><span>{formatSlots(hours[k])}</span>
            </li>
          ))}
          {source && <li className="col-span-2 text-xs text-zinc-400 mt-1" data-testid={`place-hours-source-${placeId}`}>Horaires : {source === "google" ? "Google" : "© contributeurs OpenStreetMap"}</li>}
        </ul>
      )}
    </div>
  );
};
